export default __webpack_public_path__ + "static/media/AAJM_Logo.9f5ea39d.png";